module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/gifts/gift_04-a1bc95bbb18c2e5085b6159035a88c9b.svg";